import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { IBeneficiaryService } from '../entities/IBeneficiaryService';
import { IBeneficiaryRepository } from '../entities/IBeneficiaryRepository';
import { Beneficiary, CreateBeneficiaryResponseDTO, CreateBeneficiaryRequestDTO, BeneficiaryList } from '../entities';
import { EditBeneficiaryRequest } from '../entities/EditBeneficiaryRequest';
import { DeleteBeneficiaryResponseBody } from '../entities/DeleteBeneficiaryResponseDTO';
import { EditBeneficiaryResponseBody } from '../entities/EditBeneficiaryResponseDTO';

export class BeneficiaryServiceImpl implements IBeneficiaryService {
  itemRepo: IBeneficiaryRepository;

  constructor(ir: IBeneficiaryRepository) {
    this.itemRepo = ir;

    this.GetBeneficiaries = this.GetBeneficiaries.bind(this);
    this.GetBeneficiary = this.GetBeneficiary.bind(this);
    this.CreateBeneficiary = this.CreateBeneficiary.bind(this);
    this.EditBeneficiary = this.EditBeneficiary.bind(this);
    this.DeleteBeneficiary = this.DeleteBeneficiary.bind(this);
  }

  GetBeneficiaries({
    customerId,
    page,
    perPage,
    all
  }: {
    customerId: number;
    page: number;
    perPage: number;
    all: boolean
  }): Promise<BeneficiaryList> {
    return this.itemRepo.GetBeneficiaries(customerId, page, perPage, all);
  }

  GetBeneficiary({ customerId, id }: { customerId: number; id: number }): Promise<Beneficiary> {
    return this.itemRepo.GetBeneficiary(customerId, id);
  }

  CreateBeneficiary(params: {
    customerId: number;
    data: CreateBeneficiaryRequestDTO;
    successCallback: SuccessCallback;
    error: ErrorCallback;
  }): Promise<CreateBeneficiaryResponseDTO> {
    return this.itemRepo.CreateBeneficiary(params.customerId, params.data, params.successCallback, params.error);
  }

  EditBeneficiary(params: {
    customerId: number;
    id: number;
    data: EditBeneficiaryRequest;
    successCallback: SuccessCallback;
  }): Promise<EditBeneficiaryResponseBody> {
    return this.itemRepo.EditBeneficiary(params.customerId, params.id, params.data, params.successCallback);
  }

  DeleteBeneficiary(data: GenericObject): Promise<DeleteBeneficiaryResponseBody> {
    return this.itemRepo.DeleteBeneficiary(data);
  }
}
